// LEOBlog Vorschau-iframes
function sizeIframe(id, height, showMore) {
    if (height > 1) {
        var iframe = document.getElementById(id);
        iframe.style.height = height + "px";
        var amount = iframe.src.match(/amount=\d+/);
        if(amount.length > 0) {
            if(!showMore) {
                document.querySelector("#no-more").style.display = "table"
                document.querySelector("#load-more").style.display = "none";
            }
        }
    } else {
        var iframe = document.getElementById(id);
        iframe.style.height = "0";
        //document.getElementById(id).parentNode.removeChild(document.getElementById(id));      // don't delete the first iframe; its src is taken as reference for future iframes.
        document.querySelector("#no-more").style.display = "table"
        document.querySelector("#load-more").style.display = "none";
    }
}

// LEOBlog Einstiegsseiten
function loadmorepreviews() {
    var iframe = document.createElement("iframe");
    var existing = document.querySelectorAll(".previews-iframe");
    existing = existing[existing.length - 1];
    var number = parseInt(existing.dataset.number, 10) + 1;
    var newSrc = existing.src;
    iframe.dataset.number = "" + number;
    iframe.title = "previews iframe " + number;
    iframe.id = "iframe" + number;
    iframe.name = iframe.id;
    iframe.className = "previews-iframe";
    var amount = newSrc.match(/amount=\d+/);
    if(amount.length > 0) {
        amount = parseInt(amount[0].substr("amount=".length), 10);
        var from = newSrc.match(/from\=\d+/);
        if(from.length > 0) {
            from = parseInt(from[0].substr("from=".length), 10) + amount;
            newSrc = newSrc.replace(/from\=\d+/, "from=" + from);
        }
        newSrc = newSrc.replace(/amount\=\d+/, "amount=6");
    }
    iframe.onload = function() {iframe.contentWindow.document.querySelector("a")?.focus()};
    iframe.src = newSrc.replace(/numsidebyside\=\d+/, "numsidebyside=3");
    document.getElementById("previews-iframe-container").appendChild(iframe);
}
    
(function blog() {
    // LEOBlog Vorschau-iframes
    function sizeAllIframes() {
        Array.prototype.forEach.call(document.querySelectorAll(".previews-iframe"), function(iframe) {
            if(typeof iframe.contentWindow.tellHeightToParent === "function") {     // iframe content might not be loaded yet
                iframe.contentWindow.tellHeightToParent();
            }
        });
    }
    addEventListener("resize", sizeAllIframes);

    var reverseCategories = {};         // slug to id
    document.querySelectorAll(".filterrow .dropdown-item[data-id]").forEach((ddi) => {
        reverseCategories[ddi.getAttribute("href").substring(1)] = ddi.dataset.id;      // .href contains path
    });

    var old = {
        category: null,
        fulltext: null,
        dateafter: null,
        datebefore: null
    };
    
    var fulltextsearch = document.querySelector('input[name="fulltextsearch"]');
    var datefrom = document.querySelector('input[name="datefrom"]');
    var dateto = document.querySelector('input[name="dateto"]');

    function updateResults() {
        var category = decodeURIComponent(location.hash).split("/")[0].substring(1);
        var fulltext = fulltextsearch.value;
        var dateafter = datefrom.value;
        var datebefore = dateto.value;
        if(category !== old.category || fulltext !== old.fulltext || dateafter !== old.dateafter || datebefore !== old.datebefore) {
            old.category = category;
            old.fulltext = fulltext;
            old.dateafter = dateafter;
            old.datebefore = datebefore;
            var existing = document.querySelectorAll(".previews-iframe");
            for(let i = 1; i < existing.length; ++i) {
                existing[i].remove();
            }
            existing[0].src = "/wp-content/themes/amplus/service-articles.php?&from=0&amount=2&numsidebyside=2" + (category.length ? "&cat=" + reverseCategories[category] : "") + (dateafter.length ? "&after=" + dateafter + "T00:00:00" : "") + (datebefore.length ? "&before=" + datebefore + "T23:59:59" : "") + "&search=" + encodeURIComponent(fulltext);
            document.querySelector("#no-more").style.display = "none"
            document.querySelector("#load-more").style.display = "flex";
            loadmorepreviews();
        }
    }

    function handleCategory(e) {
        var hashes = decodeURIComponent(location.hash).split("/");
        location.hash = this.getAttribute("href") + (hashes.length > 1 ? "/" + hashes[1] : "");         // this.href includes path
        e.preventDefault();
    }

    document.querySelectorAll(".filterrow input").forEach((i) => {
        i.addEventListener("input", updateResults);
    });
    document.querySelectorAll(".filterrow .js-dropdown-item").forEach((d) => {
        d.addEventListener("click", handleCategory);
    });
    addEventListener("hashchange", updateResults);

    if(location.hash.split("/")[0].substring(1).length) {
        updateResults();
    }
})();